import { render, staticRenderFns } from "./InputUploadPic.vue?vue&type=template&id=ca8e4bbc&"
import script from "./InputUploadPic.vue?vue&type=script&lang=js&"
export * from "./InputUploadPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports